import { LoaderFunction, useFetcher } from "react-router-dom";
import { activateFreeAsset } from "../../../common/api/decimal/methods/product";

export interface ActivateResult {
  ok: boolean;
  vbid?: string;
}

export const activateFreeBookAction: LoaderFunction = async ({
  params,
}): Promise<ActivateResult> => {
  if (params.vbid) {
    const response = await activateFreeAsset(params.vbid);
    return { ok: response.ok, vbid: response.data?.vbid };
  }
  return { ok: false };
};

export function useActivateFreeBookFetcher() {
  return useFetcher<ActivateResult>();
}
